import styled from "styled-components";
import Button from "@mui/material/Button";
import { connect } from "react-redux";

const PhotoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  padding: 8px 0;

  @media (max-width: 520px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
`;

const Photo = styled.img`
  width: 100%;
  aspect-ratio: 2 / 3;
  object-fit: cover;
  border-radius: 14px;
  transition: transform 0.6s var(--ease-out);
`;

const PhotoDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px 10px 14px;
  border-radius: var(--radius-card);
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);

  > div {
    overflow: hidden;
    border-radius: 14px;
  }

  &:hover img {
    transform: scale(1.04);
  }
`;

const PhotoList = ({ props }) => {
  const photos = props.props.profile.photos;
  const setProfilePic = (payload) => {
		props.props.updateProfile(props.props.user, props.props.profile, {'profile_pic':payload});
	};
  const listItems = Array.isArray(photos) ? photos.map((url) =>
    <PhotoDiv key={url}>
      <div>
        <Photo
          src={url} alt="Uploaded profile photo" loading="lazy" /></div>
      <Button variant="outlined" onClick={()=>setProfilePic(url)}>Set As Profile Pic</Button>
    </PhotoDiv>
  ) : null;

  return (
    <PhotoContainer>
      {listItems}
    </PhotoContainer>
  )
};

const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
    profile: state.profileState.profile,
  };
};

export default connect(mapStateToProps, null)(PhotoList);